module.exports = __webpack_public_path__ + "img/cooperation-logo1.f338022b.png";